import React, { Component } from 'react'
import {DropDownSort} from 'components/tt-forms';

class FormSort extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      }
    };
  }

  componentDidMount() {
    let pageData = this.props.pageDetail;
    let newState = this.state;
    this.setState({
      ...newState,
      pageData: pageData
    });
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    let pageData = nextProps.pageDetail;
    let newState = this.state;
    this.setState({
      ...newState,
      pageData: pageData
    });
  }

  render() {
    return (
      <div className='sort-container'>
        <div className='sort-by'>
          <DropDownSort
            type={this.props.type}
            className="col"
            selectedValue={this.props.selectedValue}
            onChange={ this.onChange.bind(this) }
            name="sortBy" />
        </div>
      </div>
    )
  }
}

export default FormSort


// WEBPACK FOOTER //
// ./src/components/modules/reception/form-sort/form-sort.jsx